import { api, makeApiRequest } from 'api/_init'
import { unwrapEnvelope } from 'domain/shared/envelope'
import { mapGoogleAudiencesResponse } from './mappers'

// Google-scoped (app/api/v4/integrations/connect/google/assets/audiences.py:AudiencesAPI)
// — unlike googleConversionGoals' customer_id-as-path-segment sibling,
// customer_id and type are both query params here. Omitting type merges
// remarketing+custom+combined; type=saved is the only way to reach Audience
// Manager saved audiences (never included in the default aggregate) — the
// DEMAND_GEN-only audience_resource_names source.
const googleAudiencesApi = {
  fetchAudiencesAsync: async (customerId, { type } = {}) => {
    const params = new URLSearchParams({ customer_id: customerId })
    if (type) params.append('type', type)
    const endpoint = `/integrations/connect/google/assets/audiences?${params.toString()}`
    const response = await makeApiRequest(api, 'get', endpoint)
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapGoogleAudiencesResponse(data), status }
    }
    return { error, status }
  },
}

export default googleAudiencesApi
